import api from "./api";

// GET all properties
export const fetchProjects = async () => {
    try {
        const response = await api.get("/api/projects");
        return response?.data?.projects;
    } catch (error) {
        throw error;
    }
};

// GET a property by ID
export const getProjectById = async (id) => {
    try {
        const response = await api.get(`/api/projects/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// POST (Create) a new property
export const createProject = async (formData) => {
    try {
        const response = await api.post("/api/projects", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

// PUT (Update) a property by ID
export const updateProject = async (id, data) => {
    try {
        const response = await api.put(`/api/properties/v1/${id}`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// DELETE a property by ID
export const deleteProperty = async (id) => {
    try {
        const response = await api.delete(`/api/properties/v1/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};


// 🔍 SEARCH properties based on filters
export const searchProperties = async (searchData) => {
    try {
        const response = await api.post("/api/projects/searchresult/bycustomsearch", searchData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};




export const addInterestedUser = async (propertyId, userId) => {
    try {
        const response = await api.post(`/api/projects/${propertyId}/interested`, { userId });
        return response.data;
    } catch (error) {
        return error?.response;
    }
};

// GET a property by ID
export const getProjectsByCategory = async (category) => {
    try {
        const response = await api.get(`/api/projects/category/${category}`);
        if (!response.data?.success) {
            // Return an error message instead of throwing
            return { success: false, message: response.data?.message || "No projects found in this category" };
        }
        return { success: true, projects: response.data?.projects };
    } catch (error) {
        // Handle 404 or any other error here
        if (error.response?.status === 404) {
            return { success: false, message: "No projects found for this category" };
        }

        return { success: false, message: error.message || "An unexpected error occurred while fetching projects." };
    }
};